const footerData = {
    top: [
        {
            type: 'List',
            children: [
                {
                    type: 'Link',
                    className: 'fLink',
                    text: 'Food',
                    children: [
                        {
                            text: 'Menu',
                            href: 'https://www.nandos.ie/food/menu',
                            type: 'Link'
                        },
                        {
                            text: 'What’s New',
                            href: 'https://www.nandos.ie/food/whats-new',
                            type: 'Link'
                        },
                        {
                            text: 'Recipes',
                            href: 'https://www.nandos.ie/food/recipes',
                            type: 'Link'
                        },
                        {
                            text: 'Gift Cards',
                            href: 'https://www.nandos.ie/food/gift-card',
                            type: 'Link'
                        },
                        {
                            text: 'Our Food',
                            href: 'https://www.nandos.ie/food/our-food',
                            type: 'Link'
                        }
                    ]
                },
                {
                    type: 'Link',
                    className: 'fLink',
                    text: 'Restaurants',
                    children: [
                        {
                            text: 'Find a Nando’s',
                            href: 'https://www.nandos.ie/restaurants/search',
                            type: 'Link'
                        },
                        {
                            text: 'View All Restaurants',
                            href: 'https://www.nandos.ie/restaurants',
                            type: 'Link'
                        }
                    ]
                },
                {
                    type: 'Link',
                    className: 'fLink',
                    text: 'Nando’s Card',
                    children: [
                        {
                            text: 'Join now',
                            href: 'https://www.nandos.ie/card/auth/register',
                            type: 'Link'
                        },
                        {
                            text: 'How it works',
                            href: 'https://www.nandos.ie/card/about',
                            type: 'Link'
                        },
                        {
                            text: 'Lost Card',
                            href: 'https://www.nandos.ie/card/lost-your-card',
                            type: 'Link'
                        },
                        {
                            type: 'Divider'
                        },
                        {
                            text: 'Log In',
                            href: 'https://www.nandos.ie/card/auth/login',
                            type: 'Link',
                            className: 'login'
                        }
                    ]
                },
                {
                    type: 'Link',
                    className: 'fLink',
                    text: 'Explore',
                    children: [
                        {
                            text: 'Our Blog',
                            href: 'https://www.nandos.ie/explore/blog',
                            type: 'Link'
                        },
                        {
                            text: 'The Nando’s App',
                            href: 'https://www.nandos.ie/explore/app',
                            type: 'Link'
                        },
                        {
                            text: 'Being Sustainable',
                            href: 'https://www.nandos.ie/explore/being-sustainable',
                            type: 'Link'
                        },
                        {
                            text: 'Fighting Malaria',
                            href: 'https://www.nandos.ie/explore/fightingmalaria',
                            type: 'Link'
                        },
                        {
                            text: 'This is PERi-PERi',
                            href: 'https://www.nandos.ie/explore/this-is-peri-peri',
                            type: 'Link'
                        },
                        {
                            text: 'Art',
                            href: 'https://www.nandos.ie/explore/art',
                            type: 'Link'
                        },
                        {
                            text: 'Music',
                            href: 'https://www.nandos.ie/explore/music',
                            type: 'Link'
                        }
                    ]
                },
                {
                    type: 'Link',
                    className: 'fLink',
                    text: 'Help',
                    children: [
                        {
                            text: 'Search FAQs',
                            href: 'https://help.nandos.ie/hc/en-ie',
                            type: 'Link'
                        },
                        {
                            text: 'My Account',
                            href: 'https://help.nandos.ie/hc/en-ie/categories/360003669517-My-Account',
                            type: 'Link'
                        },
                        {
                            text: 'Food',
                            href: 'https://help.nandos.ie/hc/en-ie/categories/360003674937-Our-Food',
                            type: 'Link'
                        },
                        {
                            text: 'Online Ordering',
                            href: 'https://help.nandos.ie/hc/en-ie/categories/360003673617-Online-Ordering',
                            type: 'Link'
                        },
                        {
                            text: 'Restaurants',
                            href: 'https://help.nandos.ie/hc/en-ie/categories/360003677938-Our-Restaurants',
                            type: 'Link'
                        },
                        {
                            text: 'Nando’s Card & Discounts',
                            href: 'https://help.nandos.ie/hc/en-ie/categories/360003670377-Nando-s-Cards-Gift-Cards-Discounts',
                            type: 'Link'
                        },
                        {
                            text: 'Fundraising Requests',
                            href: 'https://help.nandos.ie/hc/en-ie/articles/4403417923217-I-Am-Organising-A-Fundraising-Event-Can-You-Help-',
                            type: 'Link'
                        },
                        {
                            text: 'Sustainability',
                            href: 'https://help.nandos.ie/hc/en-ie/categories/360003678997-Sustainability',
                            type: 'Link'
                        },
                        {
                            text: 'Contact Us',
                            href: 'https://help.nandos.ie/hc/en-ie/requests/new?ticket_form_id=360000261658',
                            type: 'Link'
                        },
                        {
                            text: 'Whistleblowing',
                            href: 'https://nandosireland.whistlelink.com/',
                            type: 'Link'
                        }
                    ]
                },
                {
                    type: 'Link',
                    className: 'fLink',
                    text: 'Legal',
                    children: [
                        {
                            text: 'Terms & Conditions',
                            href: 'https://www.nandos.ie/nandos-terms-and-conditions',
                            type: 'Link'
                        },
                        {
                            href: 'https://www.nandos.ie/privacy-policy',
                            title: 'Nando’s privacy policy',
                            text: 'Privacy Policy',
                            type: 'Link'
                        },
                        {
                            href: 'https://www.nandos.ie/cookies-policy',
                            title: 'Nando’s cookie policy',
                            text: 'Cookies Policy',
                            type: 'Link'
                        },
                        {
                            type: 'Link',
                            href: '#cookiespreferences',
                            title: 'Nando’s cookie preferences',
                            text: 'Cookies Preferences',
                            action: 'open-cookies'
                        },
                        {
                            text: 'Slavery Statement',
                            href: 'https://www.nandos.ie/modern-slavery-statement',
                            type: 'Link'
                        },
                        {
                            text: 'Gender Pay Gap Report',
                            href: 'https://www.nandos.ie/genderpayreport',
                            type: 'Link'
                        },
                        {
                            text: 'Insurance Policy Details',
                            href: 'https://www.nandos.ie/insurance-policy-details',
                            type: 'Link'
                        },
                        {
                            text: 'NGHL Tax Strategy',
                            href: 'https://www.nandos.ie/nghl-tax-strategy-2021',
                            type: 'Link'
                        },
                        {
                            text: 'Stakeholder Engagement',
                            href: 'https://www.nandos.ie/stakeholder-engagement',
                            type: 'Link'
                        }
                    ]
                }
            ]
        }
    ]
};

export { footerData };
